import { Navigate, Outlet } from 'react-router-dom';
import { usePlatformAdmin } from '@/hooks/usePlatformAdmin';

/**
 * Protects admin-only routes. Redirects non-platform-admins to the dashboard.
 * Renders nothing while the access check is loading to prevent a flash of
 * founder-only content.
 */
export function AdminGuard() {
  const { isPlatformAdmin, isLoading } = usePlatformAdmin();

  if (isLoading) return null;

  if (!isPlatformAdmin) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <Outlet />;
}
